// "Why Your RAG Is Worse Than NotebookLM" — comparison short.
// Cold Compute / Neon kit. ~138s @ 30fps. Audience: RAG/agent engineers.
//
// Grounded in EAKC-MVP:
//   docs/2026-03-15-notebooklm-gap-analysis-rag-quality-roadmap.md (the gap)
//   docs/content/13-rag-retrieval-accuracy-masterclass.md (the 75→90 fixes)
//   supabase/migrations/033 + 034 (BM25 OR + camelCase split)
//   src/app/api/v1/chat/completions/route.ts L380 (the decision-tree prompt)
//   src/lib/mcp/tools-recent-docs.ts + src/lib/eval/recency-probe.ts (recency)
//   src/components/chat/CitationPreviewPanel.tsx (the citation panel)
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous (next.start = prev.start + prev.duration).
export const SCENE = {
  hook: { start: 0, duration: 150 }, //        0:00–0:05  same PDF, EAKC said "no predictions"
  gap: { start: 150, duration: 540 }, //       0:05–0:23  why NotebookLM won: whole-doc vs top-K
  notyet: { start: 690, duration: 330 }, //    0:23–0:34  the tempting fix I did NOT ship (honesty)
  fixes: { start: 1020, duration: 510 }, //    0:34–0:51  the three fixes that actually closed it
  prompt: { start: 1530, duration: 600 }, //   0:51–1:11  the decision-tree synthesis prompt (CASE A/B/C)
  recency: { start: 2130, duration: 540 }, //  1:11–1:29  recency: list_recent_docs + the eval probe
  citation: { start: 2670, duration: 420 }, // 1:29–1:43  click [Source N] → the citation panel
  payoff: { start: 3090, duration: 510 }, //   1:43–2:00  ~75% → peak 90% (code queries)
  outro: { start: 3600, duration: 330 }, //    2:00–2:11
} as const;

export const TOTAL_DURATION = 3930; // 131s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
